exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show .dropdown-toggle{background-color:var(--primary)!important;border-color:var(--primary)!important;color:#fff}.dropdown-toggle:after{display:none}.v-enter-active,.v-leave-active{transition:opacity .5s ease}.v-enter-from,.v-leave-to{opacity:0}", ""]);

// exports
